import React from "react";
import { Users } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const TargetAudienceNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={Users}
    subtitle="Audience segmentation, motivations, and messaging fit"
    badge="AUDIENCE"
    theme={{
      cardBg: "#f0fdf4",
      cardBorder: "#bbf7d0",
      heroBg: "#dcfce7",
      heroBorder: "#86efac",
      badgeBg: "rgba(34, 197, 94, 0.12)",
      badgeBorder: "#22c55e",
      iconColor: "#15803d",
      dotColor: "#22c55e",
    }}
  />
);

export default TargetAudienceNarrativeAssessmentViewer;
